<template>
  <section>
    <div class="wrapper">
      <div class="main-panel">
        <HeaderPage />
        <div class="content">
          <slot />
        </div>
        <Footer />
      </div>
    </div>
  </section>
</template>

<script>
import HeaderPage from "@/components/layout/admin/HeaderPage.vue";
import Footer from "@/components/layout/admin/FooterPage.vue";
import { mapState } from 'vuex';

export default {
  name: "MainLayout",
  components: {
    HeaderPage,
    Footer
  },
  computed: {
    ...mapState({
      adminUser: state => state.user.admin_no,
      settingLoaded: state => state.settingLoaded
    })
  },
  mounted() {
    if (this.adminUser !== "0001" && !this.settingLoaded) {
      this.$store.dispatch("getSetting");
    }
  }
};
</script>
